module.exports = __webpack_public_path__ + "static/studio_01-bf251271d6178129c7fd964f96633491.jpg";